<template>
  <TrialBanner />
  <nav class="w-full flex flex-col items-start p-4 bg-[#1E1017] text-[#FCFCFC] z-[900] font-avenir">
    <div class="flex justify-between w-full">
      <div class="text-2xl font-bold mb-2 select-none cursor-pointer" @click="$router.push('/')">Nailit</div>
      <div class="relative">
        <button
          ref="userButton"
          @click="toggleUserMenu"
          class="!text-white text-xl flex items-center !p-0 !m-0 cursor-pointer !bg-transparent "
        >
          <i class="fa-solid fa-user-circle text-2xl"></i>
        </button>
        <ul
          ref="userMenu"
          v-if="isUserMenuOpen"
          class="absolute z-1 right-0 mt-2 bg-gray-800 text-white rounded-xl shadow-lg w-fit"
        >
          <li
            @click="$router.push('/account'); closeUserMenu()"
            class="px-4 py-2 hover:bg-gray-700 cursor-pointer rounded-xl whitespace-nowrap"
          >
            Mon compte
          </li>
          <li
            @click="$router.push('/users'); closeUserMenu()"
            class="px-4 py-2 hover:bg-gray-700 cursor-pointer rounded-xl whitespace-nowrap"
            v-if="perm().users != 'none'"
          >
            Utilisateurs
          </li>
        </ul>
      </div>
    </div>
    <ul class="flex list-none p-0 m-0">
      <li class="mr-5 relative select-none" v-for="link in links" :key="link.to">
        <router-link :to="link.to" v-slot="{ isActive }">
          <a
            :class="[
              'no-underline text-[#FCFCFC] relative text-[1.3rem] transition-all duration-300',
              isActive ? 'after:visible after:scale-x-100' : 'after:invisible after:scale-x-0'
            ]"
            :style="{
              position: 'relative'
            }"
          >
            {{ link.label }}
            <span
              class="absolute left-0 -bottom-0.5 w-full h-0.5 bg-[#E8535D] transition-all duration-300"
              :class="{
                'visible scale-x-100': isActive,
                'invisible scale-x-0': !isActive
              }"
            ></span>
          </a>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import TrialBanner from "@/components/Navbars/TrialBanner.vue";

import { inject } from "vue";

export default {
  name: "NavMenu",
  components: {
    TrialBanner,
  },
  data() {
    return {
      isUserMenuOpen: false,
      links: [
        { to: "/planning", label: "Planning" },
        { to: "/projects", label: "Projets" },
        { to: "/cash", label: "Trésorerie" },
        { to: "/ideas", label: "Boîte à idées" },
        { to: "/ressources", label: "Ressources" },
        { to: "/clients", label: "Clients" }
      ],
    };
  },
  setup() {
    const perm = inject("userPerm");
    return { perm };
  },
  methods: {
    toggleUserMenu() {
      this.isUserMenuOpen = !this.isUserMenuOpen;
    },
    closeUserMenu() {
      this.isUserMenuOpen = false;
    },
    handleClickOutside(event) {
      const menu = this.$refs.userMenu;
      const button = this.$refs.userButton;
      if (menu && !menu.contains(event.target) && button && !button.contains(event.target)) {
        this.closeUserMenu();
      }
    },
  },
  async mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>